import { lazy } from 'react';

export const SbSharedPhotoHeartLazy = lazy(
    () =>
        import(
            /* webpackChunkName: "PhotoHeart" */
            'dibs-interiors-photos/exports/PhotoHeart.tsx'
        )
);
